import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useWhatsAppNumber from "../../hooks/useWhatsAppNumber";

export default function WhatsAppButton() {
  const number = useWhatsAppNumber();
  const { pathname } = useLocation();
  const isProductPage = pathname.startsWith('/product/');

  const href = `https://wa.me/${number}?text=${encodeURIComponent("Hi! I would like to enquire about a product I am interested in.")}`;

  const bottomClass = isProductPage ? 'bottom-36 md:bottom-24' : 'bottom-20 md:bottom-5';

  // Show the chat bubble briefly on landing, then fade it away.
  const [showBubble, setShowBubble] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setShowBubble(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  // Hide the floating button while the mobile search overlay is open, so it
  // doesn't sit on top of the search bar.
  const [searchOpen, setSearchOpen] = useState(false);
  useEffect(() => {
    const handler = (e) => setSearchOpen(e.detail);
    window.addEventListener('yellove:search-toggle', handler);
    return () => window.removeEventListener('yellove:search-toggle', handler);
  }, []);

  if (searchOpen) return null;

  return (
    <div className={`fixed right-5 z-50 flex flex-col items-end gap-2 ${bottomClass}`}>
      {/* Chat bubble */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`flex items-center gap-2 bg-brand-yellow shadow-md rounded-2xl pl-3 pr-4 py-2 text-xs font-semibold text-brand-dark hover:opacity-90 max-w-[130px] leading-snug transition-opacity duration-700 ${showBubble ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      >
        <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse shrink-0" />
        Hi, Have Questions?
      </a>

      {/* WhatsApp icon */}
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-110 active:scale-95"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>
    </div>
  );
}
